export const consumableAr = {
  "Note": "ملحوظة",
  "Donner une note si vous voulez": "إعطاء تقييم إذا كنت تريد",
  "Fournisseur": "المورد",
  "Consommable": "مستهلكة",
  "Quantité": "الكمية",
  "Total BC": "إجمالي أمر الشراء",
  "Total Payé": "مجموع المبالغ المدفوعة",
  "BC": "أمر شراء",
  "Les bons de commandes": "طلبات الشراء",
  "Cacher": "اخفاء",
  "Afficher": "عرض",
  "Historique de paiements": "تاريخ الدفع",
  "Reference": "المرجع",
  "List Consommable": "قائمة المواد الاستهلاكية",
  "Fournisseurs": "الموردين",
  "Debut": "البداية",
  "Fin": "النهاية",
  "Jour": "يوم",
  "Mois": "الشهر",
  "Bon de commande": "أمر شراء",


  // Server Side 

  "Le consomable deja existe.": "المادة الاستهلاكية موجودة بالفعل.",
  "Le nom du consomable est obligatoire !!": "اسم المادة الاستهلاكية إجباري!!",
  "Le montant est obligatoire": "المبلغ إلزامي",
  "Le fournisseur est obligatoire": "مطلوب المورد",
  "Les donneés du bon de commande sont obligatoire.": "تفاصيل أمر الشراء إلزامية.",
  "Donner une date valide": "إعطاء تاريخ صالح",

  "Le Fournisseur deja existe": "المورد موجود بالفعل",
  "Le nom du fournisseur est obligatoire": "اسم المورد مطلوب",
  "Le Telephone du fournisseur est obligatoire": "رقم هاتف المورد مطلوب",

  "Supprimer tous les bons de commandes de ce fournisseur, pour pouvoir le supprimer.": "احذف جميع طلبات الشراء من هذا المورد لتتمكن من حذفها.",
  


}